
const errorMessage = (error) => {
    return `Error: ${error.code}: ${error.message}`;
}

export {errorMessage};